export function getAdBreakHref(): string {
  const configuredHref = process.env.REACT_APP_AD_BREAK_URL?.trim();
  if (configuredHref) {
    return configuredHref;
  }

  if (typeof window === "undefined") {
    return "https://www.societea.app/ad-break";
  }

  if (window.location.port === "3000") {
    return "http://localhost:3005/ad-break";
  }

  return `${window.location.origin}/ad-break`;
}
